import styled from "styled-components";

// Changing CSS items: https://daypicker.dev/api/enumerations/UI
export const CalendarWrapper = styled.div`
  background-color: var(--primary-white);
  border: 1px solid var(--primary-dark-100);
  border-radius: 10px;

  .rdp-root {
    padding: 1rem 1rem 0rem 1rem;
  }

  .rdp-nav {
    background-color: var(--primary-white);
    position: absolute;
    top: unset;
    right: 0;
    left: unset;
  }

  .rdp-chevron {
    fill: var(--primary-dark-200);
  }

  .rdp-range_start .rdp-day_button,
  .rdp-range_end .rdp-day_button {
    background-color: var(--primary-blue);
  }

  > div {
    margin: 0px 0 1rem auto;
    padding: 0 1rem;

    button[id="select-date-button"] {
      border: 1px solid var(--primary-dark-100);
    }
  }
`;

export const DateGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;

  > p {
    cursor: pointer;
  }

  svg[id="calendar-week-icon"] {
    cursor: pointer;
    transition: stroke 0.3s;
    stroke: var(--primary-blue-300);
  }

  &:hover {
    svg[id="calendar-week-icon"] {
      stroke: var(--primary-blue-400);
    }
  }
`;
